import { useContext } from "react";
import { EntityPageContext } from "./EntityPageContext";

export function useEntityPage() {
  const value = useContext(EntityPageContext);

  if (!value) {
    throw new Error("useEntityPage must be used inside an EntityPageProvider");
  }

  return value;
}
